import {
  type PasswordIdentity,
  regrasCumpridas,
  senhaAceita,
} from '@alternativamais/chat-core';
import { useId, useState } from 'react';

import { Icone } from '../../componentes/Icone';

export const CLASSE_ENTRADA =
  'flex h-11 items-center gap-1 rounded-lg border bg-chat pr-1 pl-3 focus-within:border-destaque focus-within:shadow-[0_0_0_3px_rgba(245,154,69,.2)]';

/** Senha com "Mostrar" (A1, A2, U12). */
export function CampoSenha({
  rotulo,
  valor,
  aoMudar,
  autoComplete = 'new-password',
  invalido = false,
  autoFocus = false,
  descricao,
}: {
  rotulo: string;
  valor: string;
  aoMudar: (valor: string) => void;
  autoComplete?: string;
  invalido?: boolean;
  autoFocus?: boolean;
  descricao?: string;
}) {
  const id = useId();
  const [mostrar, setMostrar] = useState(false);
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-sm font-semibold text-texto-2">
        {rotulo}
      </label>
      <div
        className={`${CLASSE_ENTRADA} ${invalido ? 'border-ocupado' : 'border-borda'}`}
      >
        <input
          id={id}
          type={mostrar ? 'text' : 'password'}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          value={valor}
          aria-invalid={invalido}
          aria-describedby={descricao}
          onChange={(evento) => aoMudar(evento.target.value)}
          className="h-10 min-w-0 grow border-0 bg-transparent text-[15px] text-texto outline-none"
        />
        <button
          type="button"
          aria-label={mostrar ? 'Esconder senha' : 'Mostrar senha'}
          aria-pressed={mostrar}
          onClick={() => setMostrar(!mostrar)}
          className="flex h-[34px] items-center gap-1.5 rounded-md px-2.5 text-[13px] font-semibold text-texto-2 hover:text-texto"
        >
          <Icone nome={mostrar ? 'olho-fechado' : 'olho'} tamanho={18} />
          {mostrar ? 'Esconder' : 'Mostrar'}
        </button>
      </div>
    </div>
  );
}

/** Regras da senha cumpridas ao vivo (A2/U12). */
export function RegrasDaSenha({
  senha,
  identidade,
}: {
  senha: string;
  identidade: PasswordIdentity;
}) {
  return (
    <ul
      aria-label="Regras da senha"
      className="m-0 flex list-none flex-col gap-1 rounded-lg bg-chat p-3 text-[13px]"
    >
      {regrasCumpridas(senha, identidade).map((regra) => {
        const ok = regra.ok;
        return (
          <li
            key={regra.texto}
            className={`flex items-center gap-2 ${ok ? 'text-online' : 'text-texto-3'}`}
          >
            <Icone nome={ok ? 'check' : 'ponto'} tamanho={14} />
            <span>{regra.texto}</span>
            <span className="sr-only">{ok ? '(cumprida)' : '(pendente)'}</span>
          </li>
        );
      })}
    </ul>
  );
}

export { senhaAceita };
